import { render, staticRenderFns } from "./poi-slide-image.vue?vue&type=template&id=612a6476&"
import script from "./poi-slide-image.vue?vue&type=script&lang=ts&"
export * from "./poi-slide-image.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports